import type {
  ICompany,
  PlatformUserStyle,
  SavedSignatureModel,
  UpdateAccountSettingPayload,
  UpdateBeforePaymentPayload,
  UpdateCompanySettingPayload,
  UpdateFeaturePayload as UpdateFeaturesPayload,
  UpdateInvoicingPartialPayload as UpdateInvoicingSettingsPartialPayload,
  UpdateInvoicingPayload as UpdateInvoicingSettingsPayload,
} from "@mytour/shared";
import axios from "axios";

const apiUrl = "api/platform-users";

async function getCurrentCompany() {
  const result = await axios.get<ICompany>("api/company/current");
  return result.data;
}

async function getCurrentUserStyle() {
  const result = await axios.get<PlatformUserStyle>(`${apiUrl}/current/style`);
  return result.data;
}

async function updateBeforePayment(payload: UpdateBeforePaymentPayload) {
  await axios.post(`${apiUrl}/before-payment/`, payload);
}

async function updateAccountSettings(payload: UpdateAccountSettingPayload) {
  await axios.post(`${apiUrl}/account-settings/`, payload);
}

async function updateCompanySettings(payload: UpdateCompanySettingPayload) {
  await axios.post(`${apiUrl}/company-settings/`, payload);
}

async function updateInvoicingSettings(payload: UpdateInvoicingSettingsPayload) {
  await axios.post(`${apiUrl}/invoicing-settings/`, payload);
}

async function updateInvoicingSettingsPartial(payload: UpdateInvoicingSettingsPartialPayload) {
  await axios.post(`${apiUrl}/invoicing-settings-partial/`, payload);
}

async function updateFeatures(payload: UpdateFeaturesPayload) {
  await axios.post(`${apiUrl}/features/`, payload);
}

async function getCurrentSavedSignature(): Promise<SavedSignatureModel> {
  const result = await axios.get<SavedSignatureModel>(
    "api/platform-users/current/saved-signature"
  );
  return result.data;
}

async function withdrawCurrentSavedSignature(): Promise<SavedSignatureModel> {
  const result = await axios.delete<SavedSignatureModel>(
    "api/platform-users/current/saved-signature"
  );
  return result.data;
}

export const platformUserApiService = {
  getCurrentCompany,
  getCurrentUserStyle,
  updateBeforePayment,
  updateAccountSettings,
  updateCompanySettings,
  updateInvoicingSettings,
  updateInvoicingSettingsPartial,
  updateFeatures,
  getCurrentSavedSignature,
  withdrawCurrentSavedSignature,
};
